enum AdditionalInformationDocumentsEnum {
    LandlordsStatement = 'landlordsStatement',
    Extradocuments = 'extraDocuments',
}

export default AdditionalInformationDocumentsEnum;
